import React from 'react';
import ErrorManager from 'shared/Messages/ErrorManager';
import { ResetFormProps } from './interface';
import SetPasswordForm from '../SetPasswordForm/SetPasswordForm';
import Success from 'screens/BrokerPortal/screens/Registration/screens/components/Success';
import { Box } from 'lmc-ui-library';

import styles from '../SetPasswordForm/_SetPasswordForm.module.scss';

const ResetPassword: React.FC<ResetFormProps> = ({ handleSubmit, error, submitted }) => {
  return submitted ? (
    <Box>
      <Box.Content className={styles.setPasswordBox}>
        <Success type="reset" />
      </Box.Content>
    </Box>
  ) : (
    <>
      <SetPasswordForm
        onSubmit={handleSubmit}
        labels={{
          password: 'New password',
          confirmPassword: 'Confirm new password',
          submitLabel: 'RESET',
        }}
      />
      {error ? <ErrorManager error={error} /> : null}
    </>
  );
};

export default ResetPassword;
